import { getRangeValue, getTermValue } from '@/packages/JsonQuery';
import { EMetroTravelType } from '@/packages/api-models/common/json_query';

import { type ITagGroupConfig } from '../types';

export const undergroundTravelTime: ITagGroupConfig = {
  get({ jsonQuery }) {
    const travelType = getTermValue('only_foot')(jsonQuery);
    const travelTime = getRangeValue('foot_min')(jsonQuery);
    if (!travelType || !travelTime || !travelTime.lte) {
      return null;
    }

    return [
      {
        group: 'undergroundTravelTime',
        text: `До метро ${travelTime.lte} мин. ${travelType === EMetroTravelType.MapFoot ? 'пешком' : 'транспортом'}`,
      },
    ];
  },
  delete({ onChange }) {
    onChange(
      {
        action: 'setUndergroundTravelTime',
        arguments: [null],
      },
      {
        action: 'setUndergroundTravelType',
        arguments: [null],
      },
    );
  },
};
